import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';

import p1 from '../assets/images/portfolio-1.jpg';
import p2 from '../assets/images/portfolio-2.jpg';
import p3 from '../assets/images/portfolio-3.jpg';
import p4 from '../assets/images/portfolio-4.jpg';
import p5 from '../assets/images/smart.gif'
import p6 from '../assets/images/innovate.gif'

const IndexPage = () => (
  <Layout>
    <Header />

    <header className="masthead d-flex">
      <div className="container text-center my-auto">
        <h1 className="mb-1">{config.heading}</h1>
        <h3 className="mb-5">
          <em>{config.subHeading}</em>
        </h3>
        <Scroll type="id" element="about" offset={100}>
          <a className="btn btn-primary btn-xl" href="#Home">
            Browse Smartly..<i class="fas fa-globe-americas fa-spin"></i>
          </a>
        </Scroll>
      </div>
      <div className="overlay"></div>
    </header>



    <section
      className="content-section bg-primary text-white text-center"
      id="services"
    >
      <div className="container">
        <div className="content-section-heading">
          <h3 className="text-secondary mb-0"></h3>
          <h2 className="mb-5">Just Click..!             </h2>




       
        </div>
       
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/news">  <i className="fa fa-newspaper fa-spin"></i></a>
            </span>
            <h4>
              <strong>NEWS WEB</strong>
            </h4> 
            <p className="text-faded mb-0"></p>
          </div>
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/search">  <i className="fa fa-search fa-spin"></i></a>
            </span>
            <h4>
              <strong>SEARCH WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
        


 <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/software">  <i className="fa fa-check-circle fa-spin"></i></a>
            </span>
            <h4>
              <strong>SOFTWARE WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         





          <div className="col-lg-3 col-md-6">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/research">  <i className="fa fa-search-plus fa-spin"></i></a>
            </span>
            <h4>
              <strong>RESEARCH WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
        </div>
      </div>
    </section>


    <section className="callout">
      <div className="container text-center">
        <h2 className="mx-auto mb-5">
         Connecting..
          <em></em>
         <marquee>World<i class="fas fa-globe-americas fa-spin"></i></marquee>
        </h2>
       
      </div>
    </section>



<section
      className="content-section bg-primary text-white text-center"
      id="services"
    >
      <div className="container">
        <div className="content-section-heading">
          <h3 className="text-secondary mb-0"></h3>
          <h2 className="mb-5"></h2>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/music">  <i className="fa fa-music fa-spin"></i></a>
            </span>
            <h4>
              <strong>MUSIC WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/movie">  <i className="fa fa-film fa-spin"></i></a>
            </span>
            <h4>
              <strong>MOVIE WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         


 <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/ebooks">  <i className="fa fa-book fa-spin"></i></a>
            </span>
            <h4>
              <strong>E-BOOKS WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         





          <div className="col-lg-3 col-md-6">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/education">  <i className="fa fa-graduation-cap fa-spin"></i></a>
            </span>
            <h4>
              <strong> EDUCATION  WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
        </div>
      </div>
    </section>









    <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0"> Dream it.Believe it.</h3>
          <h2 className="mb-5">Browse Smartly</h2>
        </div>
        <div className="row no-gutters">
      
          
         
        </div>
      </div>
    </section>




<section
      className="content-section bg-primary text-white text-center"
      id="services"
    >
      <div className="container">
        <div className="content-section-heading">
          <h3 className="text-secondary mb-0"></h3>
          <h2 className="mb-5"></h2>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/social">  <i className="fa fa-share-square fa-spin"></i></a>
            </span>
            <h4>
              <strong>SOCIAL MEDIA WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/eshop">  <i className="fa fa-shopping-cart fa-spin"></i></a>
            </span>
            <h4>
              <strong>ONLINE SHOPS WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         


 <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/games">  <i className="fa fa-gamepad fa-spin"></i></a>
            </span>
            <h4>
              <strong>GAMES WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         





          <div className="col-lg-3 col-md-6">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/documentaries">  <i className="fa fa-film fa-spin"></i></a>
            </span>
            <h4>
              <strong>DOCUMENTARIES WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
        </div>
      </div>
    </section>






  <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Make it Happen. Everyday.</h3>
          <img className="img-fluid" src={p6} alt="" />
          <h2 className="mb-5">Browse Smartly</h2>
        </div>
        
          
         
        
      </div>
    </section>




<section
      className="content-section bg-primary text-white text-center"
      id="services"
    >
      <div className="container">
        <div className="content-section-heading">
          <h3 className="text-secondary mb-0"></h3>
          <h2 className="mb-5"></h2>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/nature">  <i className="fa fa-leaf fa-spin"></i></a>
            </span>
            <h4>
              <strong>NATURE WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/creativity">  <i className="fab fa-creative-commons-remix fa-spin"></i></a>
            </span>


            
            <h4>
              <strong>CREATIVITY WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         


 <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/fantasy">  <i className=" fa fa-american-sign-language-interpreting fa-spin"></i></a>
            </span>
            <h4>
              <strong>FANTASY WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         





          <div className="col-lg-3 col-md-6">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/international">  <i className="fa fa-flag-checkered fa-spin"></i></a>
            </span>
            <h4>
              <strong>INTERNATIONAL BODIES WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
        </div>
      </div>
    </section>



 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">High-Speed. Connecting the Web Together.</h3>
          <img className="img-fluid" src={p5} alt="" />
          <h2 className="mb-5">Browse Smartly</h2>
        </div>
        
          
         
        
      </div>
    </section>


<section
      className="content-section bg-primary text-white text-center"
      id="services"
    >
      <div className="container">
        <div className="content-section-heading">
          <h3 className="text-secondary mb-0"></h3>
          <h2 className="mb-5"></h2>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/sports">  <i className="fa fa-football-ball fa-spin"></i></a>
            </span>


           
            <h4>
              <strong>SPORTS WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/vidchannel">  <i className="fa fa-file-video fa-spin"></i></a>
            </span>
            <h4>
              <strong>VIDEO CHANNEL WEB</strong>
            </h4>
            <p className="text-faded mb-0">
             
            </p>
          </div>
         







          <div className="col-lg-3 col-md-6">
            <span className="service-icon rounded-circle mx-auto mb-3">
              <a href="/email">  <i className="fa fa-envelope fa-spin"></i></a>
            </span>
            <h4>
              <strong>EMAIL ACCOUNT CREATION WEB</strong>
            </h4>
            <p className="text-faded mb-0"></p>
          </div>
        </div>
      </div>
    </section>








    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4">Interconnecting the Web...</h2>
       
       
      </div>
    </section>

    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
